<div class="save-button" fxHide.lt-md [ngClass]="{ 'place-near-top': !hideNext }">
  <button
    *ngIf="!hideSave"
    mat-button
    matTooltip="Save your work"
    matTooltipPosition="above"
    matTooltipClass="edit-class"
    (click)="saveButtonClicked.emit(true)"
    class="icare-primary-action-button"
    automation-id="save-work-button-schedule-creation-state-buttons">
    Save
  </button>
</div>
<div
  *ngIf="!hideButtons"
  fxFill
  fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutGap.lt-md="20px"
  fxLayoutAlign="space-between"
  fxLayoutAlign.lt-md="space-between center">
  <div
    fxLayout="column"
    fxLayout.lt-md="row"
    class="nav-buttons">
    <button
      #backBtn
      *ngIf="!hideBack"
      mat-button
      type="button"
      matTooltip="Back / Previous"
      matTooltipPosition="above"
      matTooltipClass="edit-class"
      (click)="back(backBtn._elementRef, $event.pageY)"
      [disabled]="!validBackBtn"
      [ngClass]="!validBackBtn ? 'disabled' : ''"
      class="on-mobile icare-secondary-icon-button"
      automation-id="back-button-schedule-creation-state-buttons">
      <i class="fal fa-angle-left"></i>Back
    </button>
  </div>
  <div
    *ngIf="!hideNext"
    fxLayout="column"
    fxLayout.lt-md="row"
    [matTooltip]="validNextBtn ? 'Save and Continue' : 'Complete Required Fields'"
    matTooltipPosition="above"
    matTooltipClass="edit-class"
    class="nav-buttons">
    <button
      #nextBtn
      mat-button
      type="button"
      class="on-mobile icare-primary-icon-button"
      [disabled]="!validNextBtn"
      (click)="forward(nextBtn._elementRef, $event.pageY)"
      [ngClass]="!validNextBtn ? 'disabled' : ''"
      [matTooltipDisabled]="false"
      automation-id="next-button-schedule-creation-state-buttons">
      Next <i class="fal fa-angle-right"></i>
    </button>
  </div>
  <div fxHide.gt-sm fxLayout.lt-md="row">
    <button
      *ngIf="!hideSave"
      mat-button
      (click)="saveButtonClicked.emit(true)"
      class="icare-primary-action-button"
      automation-id="save-button-schedule-creation-state-buttons">
      Save
    </button>
  </div>
</div>
